import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { MirrorTest } from './components/MirrorTest';
import { ScienceSection } from './components/ScienceSection';
import { NerveDischarge } from './components/NerveDischarge';
import { NutritionSection } from './components/NutritionSection';
import { SleepSection } from './components/SleepSection';
import { ChecklistSection } from './components/ChecklistSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  useEffect(() => {
    document.title = 'The Cortisol Reset Blueprint';
  }, []);
  return <main className="w-full min-h-screen bg-cream selection:bg-gold selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MirrorTest data-id="element-2" />
      <ScienceSection data-id="element-3" />
      <NerveDischarge data-id="element-4" />
      <NutritionSection data-id="element-5" />
      <SleepSection data-id="element-6" />
      <ChecklistSection data-id="element-7" />
      <FaqSection data-id="element-8" />
    </main>;
}